<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Sample Type Instructions Data
    Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading title="Manage Service Instructions" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>

    <quill-editor
      v-for="(instruction, index) in sample_type.service_instructions"
      :key="index"
      v-model="message"
      :content="instruction.message"
    />
    <b-button
      @click="submit"
      class="my-4 float-right py-3 px-5"
      variant="success"
    >
      <i class="fal fa-address-book" />
      <span> Save</span>
    </b-button>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import VueQuillEditor from "vue-quill-editor";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import { notificationOptions } from "@/shared/toast-notification-options";
import { serviceInstructionNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { getModel } from "@/shared/fetch-utils";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.use(VueQuillEditor);

const ServiceInstructionRepository =
  LabRepositoryFactory.get("serviceInstruction");
Vue.use(VueNotifications, notificationOptions);

export default {
  name: "ServiceInstructionEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
  },
  data() {
    return {
      loading: true,
      laboratory: null,
      laboratory_id: this.$store.getters.getLaboratoryContext.id,
      sample_type_id: this.$route.params.sample_type_id || null,
      sample_type: null,
      service_instruction: null,
      message: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-arrow-left",
            linkto: `/sampletypes/${this.sample_type_id}`,
            title: "Back to sample type",
            variant: "info",
          },
        ],
      };
    },
  },
  methods: {
    async init() {
      this.sample_type = await getModel({
        model_type: "sample_type",
        id: this.sample_type_id,
        message: this.$bvToast,
      });
      this.laboratory = await getModel({
        model_type: "laboratory",
        id: this.laboratory_id,
        message: this.$bvToast,
      });

      this.setInstruction();

      this.loading = false;
    },
    setInstruction() {
      if (
        this.sample_type.service_instructions &&
        this.sample_type.service_instructions.length
      ) {
        this.service_instruction = this.sample_type.service_instructions[0];
      } else {
        this.service_instruction = null;
      }
    },
    submit() {
      const payload = {
        laboratory_id: this.laboratory.id,
        sample_type_id: this.sample_type_id,
        message: this.message,
      };

      if (this.instruction && this.instruction.id) {
        return ServiceInstructionRepository.update(this.instruction.id, payload)
          .then((response) => {
            if (response && response.status === 200 && response.data) {
              this.editSuccess();
            } else {
              this.editFail();
            }
          })
          .catch(() => {
            this.editFail();
          });
      } else {
        return ServiceInstructionRepository.create(payload)
          .then((response) => {
            if (response && response.status === 201 && response.data) {
              this.addSuccess();
            } else {
              this.addFail();
            }
          })
          .catch(() => {
            this.addFail();
          });
      }
    },
  },
  created() {
    this.loading = true;

    this.init();
  },
  notifications: serviceInstructionNotifications,
};
</script>
